import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { OrigemCst } from 'src/app/models/api/dados-fiscais/origem-cst';

@Injectable({
  providedIn: 'root'
})
export class ApiOrigemCstService {
  private baseUrl = 'OrigemCST';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.dadosBasicos)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<OrigemCst[]>('');
  }
}
